import { AutoMap } from "@automapper/classes";

export class SamplingPointDTO {

    id?: number;
    @AutoMap()
    code!: string;
    @AutoMap()
    name!: string;
    @AutoMap()
    address!: string;
    @AutoMap()
    city!: string;
    @AutoMap()
    zipCode!: string;
}
